// 場域樹（organization-site §2.2）：sites 平面列表 → 依 parent 排成樹，深度優先順序 + 深度（畫縮排用）。
import type { Site } from './planeApi';

export interface SiteRow {
  site: Site;
  depth: number;
  /** 根到自己的名稱路徑（「總部 / A 棟 / 3F」）。 */
  path: string;
}

export function siteRows(sites: Site[]): SiteRow[] {
  const byParent = new Map<string, Site[]>();
  const ids = new Set(sites.map((s) => s.site_id));
  for (const s of sites) {
    const p = s.parent_site_id && ids.has(s.parent_site_id) ? s.parent_site_id : '';
    const list = byParent.get(p) ?? [];
    list.push(s);
    byParent.set(p, list);
  }
  for (const list of byParent.values()) list.sort((a, b) => a.name.localeCompare(b.name));
  const out: SiteRow[] = [];
  const seen = new Set<string>();
  const walk = (parent: string, depth: number, prefix: string) => {
    for (const s of byParent.get(parent) ?? []) {
      if (seen.has(s.site_id)) continue; // 防資料循環
      seen.add(s.site_id);
      const path = prefix ? `${prefix} / ${s.name}` : s.name;
      out.push({ site: s, depth, path });
      walk(s.site_id, depth + 1, path);
    }
  };
  walk('', 0, '');
  return out;
}

/** 子樹（含自己）的 site_id：搬移時不能搬到自己底下。 */
export function subtreeIds(sites: Site[], rootId: string): Set<string> {
  const out = new Set<string>([rootId]);
  let grew = true;
  while (grew) {
    grew = false;
    for (const s of sites) {
      if (s.parent_site_id && out.has(s.parent_site_id) && !out.has(s.site_id)) {
        out.add(s.site_id);
        grew = true;
      }
    }
  }
  return out;
}

